import { Router } from 'react-router';
import { noop } from './helpers';
import { AuthModel } from '../modules/auth/model';
import { FlashController } from '../modules/flash/controller';
import {FlashMessageTypeNoUser} from '../types';

let initial = true;

export const defaultTitle = 'Lickd music licensing for YouTube, Facebook and online video creators';
export const defaultDescription = 'Lickd music licensing for YouTube, Facebook and online video creators';

export const clearInitial = () => initial = false;

export const maybeSkip = (onEnter: Router.EnterHook): Router.EnterHook => {
  return async (nextState: Router.RouterState, replace: Router.RedirectFunction) => {
    if (initial && !process.env.SERVER) {
      initial = false;
      return;
    }

    await onEnter(nextState, replace);
    return;
  };
};

export const clientOnly = (onEnter: Router.EnterHook): Router.EnterHook => {
  return async (nextState: Router.RouterState, replace: Router.RedirectFunction) => {
    if (process.env.SERVER) return;
    if (initial) initial = false;

    await onEnter(nextState, replace);
    return;
  };
};

export const passThrough = (onEnter: Router.EnterHook): Router.EnterHook => {
  return async (nextState: Router.RouterState, replace: Router.RedirectFunction) => {
    initial = false;

    await onEnter(nextState, replace);
    return;
  };
};

export const requireAuth = (onEnter: Router.EnterHook, auth: AuthModel, flash: FlashController): Router.EnterHook => {
  return async (nextState: Router.RouterState, replace: Router.RedirectFunction) => {
    if (!!process.env.SERVER) return;
    if (initial) initial = false;

    if (!auth.user) {
      flash.createMessage(FlashMessageTypeNoUser, { redirectTo: nextState.location.pathname });
      replace({pathname: '/'});
      return;
    }

    await onEnter(nextState, replace);
    return;
  }
};

export const onEnterNoop = maybeSkip(noop);